import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from "@angular/router";
import { CommonFunctionService } from "./../../../services/Common/common-function.service";
import { UserMerchantData } from "./../../../services/Common/common-function.service";
import { PayoutService } from 'src/app/services/payout.service';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-pay-outbatchdetails',
  templateUrl: './pay-outbatchdetails.component.html',
  styleUrls: ['./pay-outbatchdetails.component.scss']
})
export class PayOutbatchdetailsComponent implements OnInit {
  excelDataResponse =[];
  rows = [];
  Id:any;
  BatchTime:any;
  BatchNetAmount:any;
  MerchantKeyId:any;
  TotalTransactionCount:any;

  viewid:any;
  TransactionType:any;
  UpdatedDateTime:any;
  constructor(private route: ActivatedRoute,private service: PayoutService, private commonfunction: CommonFunctionService) { 
    this.route.params.subscribe(params => {
      this.viewid = params['id'];
    });
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
   this.service.ViewPayOutBatchView(this.viewid, merchantdata.MerchantKeyId).subscribe(result => {
    this.Id= result.Id
    this.MerchantKeyId=result.MerchantKeyId
    this.TotalTransactionCount=result.TotalTransactionCount;
    this.TransactionType=result.TransactionType;
    this.BatchTime=result.BatchTime;
    this.BatchNetAmount=result.BatchNetAmount;
    this.UpdatedDateTime=result.UpdatedDateTime;

    this.service.ViewPayOutBatchDetails(this.Id, merchantdata.MerchantKeyId).subscribe(result => {
      this.rows=result
    });
  });
}

  ngOnInit() {
  }


  readAndExportToExcelData()
  {
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
  
   if(this.rows.length>0)
   {
     this.rows.forEach(element =>{
      var manageBatchArray = {'PayOut BatchId':element.PayOutBatchId,'Payout TransactionId':element.PayoutTransactionId,'Payment Type':element.PaymentType,'Transaction Type':element.TransactionType,'Transaction Amount':element.TransactionAmount,'Date Time' :element.RecordDateTime}
      this.excelDataResponse.push(manageBatchArray);


      // var manageBatchArray = {'PayOut BatchId':element.PayOutBatchId,
      // 'Payout TransactionId':element.PayoutTransactionId,
      // 'Payment Type':element.PaymentType,
      // 'Transaction Type':element.TransactionType,
      // // 'Transaction Amount':element.TransactionAmount,
      // 'Date Time' :element.RecordDateTime}
      // this.excelDataResponse.push(manageBatchArray);
    });

    const manageBatchWorkSheet = XLSX.utils.json_to_sheet(this.excelDataResponse,{header:['PayOut BatchId', 'Payout TransactionId','Payment Type','Transaction Type','Transaction Amount','Date Time']});
    XLSX.utils.book_append_sheet(workBook, manageBatchWorkSheet, 'ManageBatch_tbl');

    // const manageBatchWorkSheet = XLSX.utils.json_to_sheet(this.excelDataResponse,{header:[
    //   'PayOut BatchId',
    //   'Payout TransactionId',
    //   'Payment Type',
    //   'Transaction Type',
    //   'TransactionAmount1',
    //   'Date Time']});
    // XLSX.utils.book_append_sheet(workBook, manageBatchWorkSheet, 'ManageBatch_tbl');
}
XLSX.writeFile(workBook,"Excel" + new Date().getTime() + '.xlsx');
this.excelDataResponse =[];

  }


}
